'use client';

import React, { createContext, useEffect, useState, ReactNode, FC } from 'react';

interface DataContextType {
  dataCart: any[];
  updateCart: (data: any[]) => void;
  selectedProduct: any | null; // Lưu sản phẩm hiện tại (bao gồm biến thể được chọn)
  updateSelectedProduct: (product: any) => void; // Hàm cập nhật sản phẩm
}

export const DataContextCart = createContext<DataContextType | undefined>(
  undefined
);

interface DataProviderProps {
  children: ReactNode;
}

export const DataCartProvider: FC<DataProviderProps> = ({ children }) => {
  const [dataCart, setDataCart] = useState<any[]>([]);

  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);

  useEffect(() => {
    try {
      const storedCart = localStorage.getItem('cartNew');
      setDataCart(storedCart ? JSON.parse(storedCart) : []);
    } catch (error) {
      console.error('Error loading cart from localStorage:', error);
      setDataCart([]);
    }
  }, []);

  const updateCart = (data: any[]) => {
    localStorage.setItem('cartNew', JSON.stringify(data));
    setDataCart([...data]);
  };

  const updateSelectedProduct = (product: any) => {
    setSelectedProduct(product);
  };

  return (
    <DataContextCart.Provider
      value={{ dataCart, updateCart, selectedProduct, updateSelectedProduct }}
    >
      {children}
    </DataContextCart.Provider>
  );
};

export const useDataCart = () => {
  const context = React.useContext(DataContextCart);
  if (!context) {
    throw new Error('useDataCart must be used within a DataCartProvider');
  }
  return context;
};
